import Base from './base'

const UNGROUPED_ID = 0

// @namespace Model
export default class ParticipantGroup extends Base {
  urlRoot () {
    return '/api/participant_groups'
  }

  isUngrouped () {
    return this.id === UNGROUPED_ID
  }

  inviteUrl () {
    return this.get('invite_url')
  }

  /*
   * assign all participants from the passed
   * in Backbone.Collection that aren't
   * already in this group
   */
  assign (participants) {
    let add

    if (participants === 'all') {
      add = 'all'
    } else {
      add = []

      participants.each(participant => {
        if (!participant.groupIds().includes(this.id)) {
          // prepare the participant to be added on the server
          add.push(participant.id)

          // add the participant to this group on the client
          participant.get('groups').add(this)
        }
      })
    }

    if (add.length) {
      const data = {
        participants: {
          add
        }
      }

      this.save(data, { patch: true })
    }
  }

  /*
   * unassign all participants from the passed
   * in Backbone.Collection that aren't
   * already in this group
   */
  unassign (participants) {
    let remove

    if (participants === 'all') {
      remove = 'all'
    } else {
      remove = []

      participants.each(participant => {
        if (participant.groupIds().includes(this.id)) {
          // prepare the participant to be removed on the server
          remove.push(participant.id)

          // remove the participant from this group on the client
          const participantGroups = participant.get('groups')

          const group = participantGroups.get(this)
          return participantGroups.remove(group)
        }
      })
    }

    if (remove.length) {
      const data = {
        participants: {
          remove
        }
      }

      this.save(data, { patch: true })
    }
  }
}
